/**
 * System-wide user roles, as issued by the backend in the `User.roles` claim.
 * Single source of truth — reference `Role.X` rather than string literals.
 */
export const Role = {
  SystemAdmin: 'SystemAdmin',
  CompanyOwner: 'CompanyOwner',
} as const;

export type Role = (typeof Role)[keyof typeof Role];
